import { render, staticRenderFns } from "./BusinessUsersEdit.vue?vue&type=template&id=71041122&"
import script from "./BusinessUsersEdit.vue?vue&type=script&lang=js&"
export * from "./BusinessUsersEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports